import classes from "./RadioInput.module.css"

type Props = {
  name: string;
  id: string;
  checked: boolean;
  onChange: () => void;
};
const RadioInput: React.FC<Props> = ({ name, id, checked, onChange }) => {
  return (
    <div className={classes.inputMain}>
      <input
        type='radio'
        name='radio'
        onChange={onChange}
        id={id}
        checked={checked}
      />
      <label htmlFor={id}>{name}</label>
    </div>
  );
};

export default RadioInput;